
import React,{useEffect} from "react"
import {  styled } from '@mui/material/styles';
import { Box,CircularProgress,  Typography,useMediaQuery } from '@mui/material';
import facebookIcon from "assets/images/landing/facebookIcon.svg"
import youtubeIcon from "assets/images/landing/youtube.svg"
import LinkedinIcon from "assets/images/landing/LinkedinIcon.svg"
import TwitterIcon from "assets/images/landing/twitterIcon.svg"
import { useTheme } from "@mui/material/styles";
import { Link } from 'react-router-dom';
import { getSettings } from 'store/slices/userLoginAction';
import { connect, useSelector } from "react-redux";

// ==============================|| LANDING - FOOTER PAGE ||============================== //

const FooterPage = ({getSettings}) => {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down("sm"));
  const[loading,setLoading]=React.useState(false)
  const {settings} = useSelector((state) => state.auth); 

       useEffect(()=>{
            setLoading(true)
            getSettings().then((res)=>{ setLoading(false)})  
        },[])

    const FooterSubWrapper = styled('div')(({ theme }) => ({
        padding:matchDownSM ? "17px 10px": '17px 20px',
        color: '#fff',
        background: '#D52F44',
        height:"48px",
        display:"flex",
        justifyContent:"space-between",
        [theme.breakpoints.down('md')]: {
            textAlign: 'center'
        }
    }));
    return (
        <>
         
            <FooterSubWrapper>
              <Box sx={{}}><Link to="/privacy-policy" style={{textDecoration:"none",color:"#fff"}}><Typography sx={{fontSize:"12px",textDecoration:"underline",textUnderlineOffset:"3px"}}>Privacy Policy</Typography></Link></Box>
                    <Typography variant="subtitle2" component="div" color="inherit" sx={{fontSize:"12px"}}>
                    © 2024 All Rights Reserved. 
                    </Typography>
                     <Box sx={{display:"flex",alignItems:"center",gap:1}}>
                        {loading ?<CircularProgress sx={{color:"#fff"}} variant="indeterminate" size={15} /> : settings?.facebook?
                     <a href={settings?.facebook} target="_blank" rel="noopener noreferrer">
                    <img src={facebookIcon} alt="facebook"/>
                    </a> :null}
                    {loading ?<CircularProgress sx={{color:"#fff"}} variant="indeterminate" size={15} /> : settings?.linkedIn?
                    <a href={settings?.linkedIn} target="_blank" rel="noopener noreferrer">
                    <img src={LinkedinIcon} alt="LinkedinIcon"/>
                    </a>:null}
                     {loading ?<CircularProgress sx={{color:"#fff"}} variant="indeterminate" size={15} /> : settings?.twitter?
                    <a href={settings?.twitter} target="_blank" rel="noopener noreferrer">
                    <img src={TwitterIcon} alt="TwitterIcon"/>
                    </a>:null}
                     {loading ?<CircularProgress sx={{color:"#fff"}} variant="indeterminate" size={15} /> : settings?.youtube?
                    <a href={settings?.youtube} target="_blank" rel="noopener noreferrer">
                    <img src={youtubeIcon} alt="TwitterIcon"/>
                    </a>:null}                    
                     </Box>
            </FooterSubWrapper>
        </>
    );
};

export default connect(null,{getSettings})(FooterPage) ;
